<template>
    <div>
        <keep-alive>
            <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">
                <el-form-item label="优惠券名称">
                    <el-input v-model="formParam.couponName" placeholder="请输入优惠券名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="initList">查询</el-button>
                </el-form-item>
            </el-form>
        </keep-alive>
        <tablePagination :total="total" :pageSize="formParam.pageSize" @handlePage="handlePage">
            <el-table :data="tableList" border size="mini">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="tmallCouponName" label="优惠券名称"></el-table-column>
                <el-table-column label="标签">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.tagName"
                                   filterable
                                   clearable
                                   allow-create
                                   @change="saveCouponTag(scope.row)"
                                   placeholder="可直接输入新标签">
                            <el-option v-for="item in tagList"
                                       :key="item"
                                       :label="item"
                                       :value="item">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <!--          <el-table-column label="操作" fixed="right" width="140">
                            <template slot-scope="scope">
                                <el-button type="success" plain size="mini" @click="toDetail(scope.row.refundNo,scope.row.orderNo,2)">查看</el-button>
                            </template>
                          </el-table-column>-->
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formParam.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formParam.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
                </el-pagination>
            </div>
        </tablePagination>
    </div>
</template>

<script>
import {listCoupon, listTags, tagCoupon} from '@/api/api';

export default {
    data() {
        return {
            formParam: {
                pageSize: 30,
                currentPage: 1,
                couponName: '',
                recordsTotal: 0
            },
            tableList: [],
            tagList: []
        }
    },
    mounted() {
        this.initList();
        this.initTags();
    },
    methods: {
        initList() {
            listCoupon(this.formParam).then(res => {
                this.formParam.recordsTotal = res.data.total;
                this.tableList = res.data.list;
            });
        },
        initTags() {
            listTags().then(res => {
                this.tagList = res.data.value;
            });
        },
        handlePage(page) {
            this.formParam.currentPage = page;
            this.initList();
        },
        // 更新物流信息
        saveCouponTag(row) {
            // let _row = row;
            // console.log("row",row);
            // console.log("row.id",row.id);
            // console.log("row.tagName",row.tagName);
            // console.log("row.tmallCouponName",row.tmallCouponName);
            if (row.id == null) {
            } else {
                tagCoupon({id: row.id, tagName: row.tagName}).then(res => {
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                    this.initTags();
                });
            }
        },
        returnHistory() {
            window.history.back()
        },
        handleSizeChange(val) {
            this.formParam.pageSize = val;
            this.initList();
        },
        handleCurrentChange(val) {
            this.formParam.currentPage = val;
            this.initList();
        }
    }
}
</script>

<style scoped>
.expand-title {
    width: 70px;
    color: #444548;
    line-height: 30px;
    text-align: right;
    margin-right: 10px;
    font-weight: 600;
}

.expand-flex {
    justify-content: flex-start;
    align-items: center;
    align-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/taobao/tmallCouponTag.vue